import { AppErrorItem } from './app-error-item';

/**
 * AppError representa una excepción de la aplicación.
 */
export class AppError extends Error {
  /**
   * Código de error.
   */
  codes: AppErrorItem[];

  /**
   * Crea una instancia de AppError.
   * @param message Mensaje de error.
   * @param codes Códigos de error.
   */
  constructor(message: string, codes: AppErrorItem[]) {
    super(message);
    this.codes = codes;
  }

  /**
   * construye una instancia de AppError
   */
  static build(message: string, codes: AppErrorItem[]): AppError {
    return new AppError(message, codes);
  }

  /**
   * Devuelve el código de error principal.
   */
  get root() {
    return this.codes[0];
  }

  /**
   * Devuelve códigos de error secundarios.
   */
  get subs() {
    return this.codes.slice(1);
  }
}
